import type { CrossBrandBootstrapDto } from "../types";
import { fetchCrossBrandBootstrap } from "../api/fetchBootstrap";

let cached: CrossBrandBootstrapDto | null = null;
let loading: Promise<CrossBrandBootstrapDto | null> | null = null;

export function getCrossBrandBootstrapCache(): CrossBrandBootstrapDto | null {
  return cached;
}

export async function ensureCrossBrandBootstrap(
  includeClientDetect = false
): Promise<CrossBrandBootstrapDto | null> {
  if (cached) return cached;
  if (loading) return loading;
  loading = fetchCrossBrandBootstrap(includeClientDetect).then((data) => {
    cached = data;
    loading = null;
    return data;
  });
  return loading;
}

export function invalidateCrossBrandBootstrap(): void {
  cached = null;
}
